import { Link } from 'react-router-dom'

const sectionStyle = {
  marginTop: '1.5rem',
  borderTop: '1px solid #332211',
  paddingTop: '1rem',
}

const labelStyle = {
  fontSize: '0.7rem',
  letterSpacing: '0.15em',
  color: '#664422',
  textTransform: 'uppercase',
  marginBottom: '0.6rem',
}

const rowStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  padding: '0.35rem 0',
  borderBottom: '1px solid #1a1208',
  fontFamily: "'Silkscreen', monospace",
  fontSize: '0.8rem',
  color: '#e8d5a0',
}

// Renders a read-only list of dungeons this NPC is placed in,
// derived from npc.dungeon_placements already loaded by the show endpoint.
export const NpcDungeonList = ({ npc }) => {
  const placements = npc?.dungeon_placements ?? []

  return (
    <div style={sectionStyle}>
      <div style={labelStyle}>Placed in Dungeons</div>

      {placements.length === 0 && (
        <div style={{ fontSize: '0.75rem', color: '#664422' }}>
          Not placed in any dungeon yet.
        </div>
      )}

      {placements.map((p) => {
        const dungeon = p.Dungeon
        return (
          <div key={p.id} style={rowStyle}>
            <span style={{ flex: 1 }}>{dungeon?.name ?? '—'}</span>
            <span style={{ color: '#664422', fontSize: '0.72rem' }}>
              Lv {p.level_index} · ({p.x}, {p.y})
            </span>
            {dungeon?.slug && (
              <Link
                to={`/admin/dungeons/${dungeon.slug}/edit`}
                style={{ fontSize: '0.72rem', color: '#8a6030' }}
              >
                edit dungeon
              </Link>
            )}
          </div>
        )
      })}
    </div>
  )
}
